/**
 * Created by ALEC ;) 666/666/666
 */


import BaseStore from './base-store.js';
import TranslationConstants from '../constants/translation.js';
import Environment from '../constants/environment.js';
import Curriculum from '../classes/curriculum.js';

class TranslationStore extends BaseStore {

    constructor(){
        super();
        this.subscribe(() => this._registerToActions.bind(this));
        this.curriculums = null;
    }

    _registerToActions(action) {

        switch(action.actionType){
            case TranslationConstants.UPDATE_ALL_CURRICULUMS_TRANS:
                var currs = action.response;
                currs.unshift({note:"All"});
                this.curriculums = currs.map(function(curriculum){
                    return curriculum;
                });
                break;
            case TranslationConstants.TRANS_DATA_GOT:
                this.data = action.response;
                break;
            case TranslationConstants.TRANS_UPDATE_GOT:
                this.unappliedChanges = action.response;
                break;
            case TranslationConstants.GOT_ALL_LANGUAGES_RAW:
                this.languages = action.response;
                break;
            case TranslationConstants.TRANS_UPDATE_GOT_CONTENT:
                var content = action.response;
                this.englishTranslationOfUid = content.englishTranslationOfUid;
                this.relevantLanguages = content.relevantLanguages;
                break;
            case TranslationConstants.NEW_TRANS_ADDED_CONTENT:
                this.newTranslationUid = action.response[0].uid;
            default: break;
        }

        this.emitChange();
    }

}

export default new TranslationStore();


// WEBPACK FOOTER //
// ./src/store/translation-store.js